// extracted by mini-css-extract-plugin
export default {"searchSection":"SearchBar_searchSection__1soiy","bar":"SearchBar_bar__TaPzC","button":"SearchBar_button__J8MD4"};